import filter from 'lodash/filter';

import {
  getOfferByIdLocally,
  getOfferByIdAndVersionIdRemotely,
  getStatesEnrolmentsContentSettingsForPathOfferLocally,
  getStatesEnrolmentsContentSettingsForPathOfferRemotely,
  fetchLatestOfferFromCloudfront
} from './DataService';

export async function fetchPathOfferLocally(pathOfferId, userId) {
  try {
    const pathOffer = await getOfferByIdLocally(pathOfferId);
    if (!pathOffer) throw new Error('OFFER_NOT_FOUND');
    const {
      states,
      enrolments,
      contentSettings
    } = await getStatesEnrolmentsContentSettingsForPathOfferLocally(pathOfferId, userId);

    return {
      pathOffer,
      states: filter(states),
      enrolments: filter(enrolments),
      contentSettings: filter(contentSettings)
    };
  } catch (error) {
    return null;
  }
}

export async function fetchPathOfferRemotely(pathOfferId, userId) {
  try {
    const {
      states,
      enrolments,
      contentSettings
    } = await getStatesEnrolmentsContentSettingsForPathOfferRemotely(pathOfferId, userId);
    const pathOfferEnrolment = enrolments.find(e => e.contentId === pathOfferId);
    let pathOffer = null;

    if (pathOfferEnrolment) {
      pathOffer = await getOfferByIdAndVersionIdRemotely(pathOfferId, pathOfferEnrolment.versionId);
    } else {
      pathOffer = await fetchLatestOfferFromCloudfront(pathOfferId);
    }

    return {
      pathOffer,
      states: filter(states),
      enrolments: filter(enrolments),
      contentSettings: filter(contentSettings)
    };
  } catch (error) {
    throw error;
  }
}
